import * as React from 'react';
import DateTemplate from '../../../../../../../ui/templates/columns/DateTemplate';
import NameTemplate from '../../../../../../../ui/templates/columns/NameTemplate';
import PrwcDataTableBasic from '../../../../../../../ui/widgets/custom/PrwcDataTableBasic';

const UserReportingManagers = () => {
  const data = [
    {
      id: 1,
      name: "Manager_One",
      validFrom: "3/12/2020",
      validTo: "14/2/2020",
    },
    {
      id: 2,
      name: "Manager_two",
      validFrom: "3/12/2020",
      validTo: "14/2/2020",
    },
    {
      id: 3,
      name: "Manager_three",
      validFrom: "3/12/2020",
      validTo: "14/2/2020",
    },
    {
      id: 4,
      name: "Manager_four",
      validFrom: "3/12/2020",
      validTo: "14/2/2020",
    },
  ];

  const dataTable = {
    columns: [
      {
        field: "reportingManager",
        headerLabelKey: "users.label.reportingManager",
        bodyTemplate: NameTemplate,
        templateArgument: "name",
        className: "w-2/4 text-xs font-semibold text-blue-700"
      },
      {
        field: "validFrom",
        headerLabelKey: "users.label.validFrom",
        bodyTemplate: DateTemplate,
        className: "w-1/4 text-xs"
      },
      {
        field: "validTo",
        headerLabelKey: "users.label.validTo",
        bodyTemplate: DateTemplate,
        className: "w-1/4 text-xs"
      },
    ],
  };

  return (
    <div>
      <PrwcDataTableBasic data={data} columns={dataTable.columns}></PrwcDataTableBasic>
    </div>
  );
};

export default UserReportingManagers;
